import PropTypes from 'prop-types';

import { Box, Paper, Typography } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

const DashboardBarChart = ({
  metricType = 'proposals', title = '', barchartData = []
}) => {
  const getChartConfig = () => {
    switch (metricType) {
      case 'latency':
        return {
          title: title,
          data: barchartData.length > 0 ? barchartData : [],
          xAxisKey: 'module',
          bars: [{ key: 'avg_duration', name: 'Avg Duration (S)', color: '#ed6c02' }]
        };
      case 'cost':
        return {
          title: title,
          data: barchartData.length > 0 ? barchartData : [],
          xAxisKey: 'module',
          bars: [
            { key: 'total_input_tokens', name: 'Input Tokens', color: '#2e7d32' },
            { key: 'total_output_tokens', name: 'Output tokens', color: '#7b1fa2' },
          ]
        };
      case 'proposals':
      default:
        return {
          title: title,
          subTitle: 'Mean performance scores across generated proposal',
          data: barchartData.length > 0 ? barchartData : [],
          xAxisKey: 'section_name',
          bars: [{ key: 'avg_score', name: 'Avg Score', color: '#1976d2' }]
        };
    }
  };

  const config = getChartConfig();

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        borderRadius: 2,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box'
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight={600} color="text.primary">
          {config.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {config.subTitle}
        </Typography>
      </Box>

      <Box sx={{ width: '100%', height: 350 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={config.data}
            margin={{ top: 10, right: 30, left: 0, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" />

            <XAxis
              dataKey={config.xAxisKey}
              tick={{ fontSize: 12, fill: '#666' }}
              interval={0}
            />

            <YAxis
              tick={{ fontSize: 12, fill: '#666' }}
              domain={[0, 10]}
            />

            <Tooltip
              contentStyle={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                border: '1px solid #ccc',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
            />

            <Legend wrapperStyle={{ paddingTop: 10 }} />

            {config.bars.map((b) => (
              <Bar
                key={b.key}
                dataKey={b.key}
                name={b.name}
                fill={b.color}
                radius={[4, 4, 0, 0]}
                barSize={36}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

DashboardBarChart.propTypes = {
  metricType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  barchartData: PropTypes.array.isRequired,
};

export default DashboardBarChart;